import { AppShellProps, AppShell as MantineAppShell } from '@mantine/core'

export const AppShell = (props: AppShellProps) => <MantineAppShell {...props} />

AppShell.Main = MantineAppShell.Main
AppShell.Header = MantineAppShell.Header
AppShell.Navbar = MantineAppShell.Navbar
AppShell.Footer = MantineAppShell.Footer
AppShell.Section = MantineAppShell.Section
